export default "King Arthur is sick and Merlin is busy tending to him. It is up to you, Merlins apprentices, to find the cure that can heal Arthur. ";